import { __read, __values } from "tslib";
/**
 * Takes a tuple of strings, and returns an object where each string is represented as a key
 * on the object with the _same_ value.
 *
 * Does some basic enforcement of feature name structure.
 */
var declareFeatureNames = function (featureNames) {
    var e_1, _a;
    var obj = {};
    var featureCodes = {};
    try {
        for (var featureNames_1 = __values(featureNames), featureNames_1_1 = featureNames_1.next(); !featureNames_1_1.done; featureNames_1_1 = featureNames_1.next()) {
            var featureName = featureNames_1_1.value;
            if ("undefined" === 'development') {
                var _b = __read(featureName.split('_'), 2), code = _b[1];
                if (code in featureCodes) {
                    throw new TypeError("Multiple feature names declared with code \"".concat(code, "\".\n                    Each feature name must have a unique code."));
                }
                featureCodes[code] = undefined;
            }
            obj[featureName] = featureName;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (featureNames_1_1 && !featureNames_1_1.done && (_a = featureNames_1.return)) _a.call(featureNames_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return obj;
};
export { declareFeatureNames };
//# sourceMappingURL=declareFeatureNames.js.map